import { Notification, STATUS_TYPES } from 'dyl-components';

import routes from 'actions/routes';
import { generateReadActionCreator, generateCreateActionCreator, generateDeleteActionCreator, generateUpdateActionCreator } from 'actions/crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';

const onDeleteSuccess = () => {
    Notification.alert('Successfully deleted category!', STATUS_TYPES.SUCCESS, true);
}

const onDeleteFailure = () => {
    Notification.alert('Failed to delete category', STATUS_TYPES.ERROR, true);
}

const getListOfTagCategories = generateReadActionCreator(routes.API_TAGS_CATEGORIES, ACTION_NAMES.TAG_CATEGORIES);
const addTagCategory = generateCreateActionCreator(routes.API_TAGS_CATEGORY, ACTION_NAMES.TAG_CATEGORIES, () => {});
const updateTagCategory = generateUpdateActionCreator(routes.API_TAGS_CATEGORY, ACTION_NAMES.TAG_CATEGORIES, () => {})
const deleteTagCategory = generateDeleteActionCreator(routes.API_TAGS_CATEGORY, ACTION_NAMES.TAG_CATEGORIES, onDeleteSuccess, onDeleteFailure);
const checkTagCategoryOrSubcategoryAvailability = generateCreateActionCreator(routes.APT_TAGS_CATEGORY_VALIDATE, ACTION_NAMES.TAG_CATEGORIES_DUPLICATE_VALIDATE)

export default {
    getListOfTagCategories,
    addTagCategory,
    deleteTagCategory,
    updateTagCategory,
    checkTagCategoryOrSubcategoryAvailability
};
